<template>
  <dashboard-layout>
    <operation-definitions-list-card
        :operation-definitions="operationDefinitions"
        @focusedChanged="focusedChanged"
        @add="onAdd"
        @delete="onDelete"
        @duplicate="onDuplicate"
    />
    <operation-definition-form-card
        v-if="focusedDefinition != null"
        :operation-definition="focusedDefinition"
        @save="save"
    />
  </dashboard-layout>
</template>

<script>
import DashboardLayout from "../components/layout/DashboardLayout";
import OperationDefinitionsListCard from "../cards/OperationDefinitionsListCard";
import {mapGetters} from "vuex";
import OperationDefinitionFormCard from "../cards/OperationDefinitionFormCard";

export default {
  name: "OperationDefinitionsView",
  components: {OperationDefinitionFormCard, OperationDefinitionsListCard, DashboardLayout},
  data: function () {
    return {
      focusedDefinition: null
    }
  },
  computed: {
    ...mapGetters({
      operationDefinitions: "operationDefinitions/operationDefinitions"
    })
  },
  mounted() {
    this.$store.dispatch("operationDefinitions/refreshOperationDefinitions");
  },
  methods: {
    focusedChanged(selectedItems) {
      this.focusedDefinition = selectedItems;
    },
    onAdd(newItem) {
      this.focusedDefinition = newItem;
    },
    onDuplicate(newItem) {
      this.focusedDefinition = newItem;
    },
    onDelete(definition) {
      this.$store.dispatch("operationDefinitions/deleteOperationDefinition", definition)
          .then(() => this.$store.dispatch("operationDefinitions/refreshOperationDefinitions"), (err) => {
            this.$notify({
              group: 'application',
              title: 'Deletion failed',
              text: `Cannot delete definition, there are operations present`,
              type: "error"
            })
          })
    },
    save(newItem) {
      this.$store.dispatch("operationDefinitions/saveOperationDefinition", newItem)
          .then(() => this.$store.dispatch("operationDefinitions/refreshOperationDefinitions"))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
